import { AppNS } from 'app';

import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { apiGetUserEmployments } from '../';

interface GetUserEmploymentsParams extends AppNS.Params {
  user_id: string;
}

export const useGetUserEmploymentsQuery = (
  params: GetUserEmploymentsParams,
  queryOptions: UseQueryOptions<AppNS.Employment[], string[], AppNS.Employment[]> = {}
) => {
  return useQuery({
    queryKey: ['user-employments', params.user_id],
    queryFn: () => apiGetUserEmployments(params),
    enabled: params.user_id !== '',
    ...queryOptions,
  });
};
